import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const moment = require('moment');
import { withRouter } from 'react-router-dom';

const Globals = require('../../../../app/globals');
const UriUtil = require('../../util/UriUtil');
import WithContentBlockPlayButton from '../DataHOCs/WithContentBlockPlayButton';

const propTypes = { 
    // set by WithPlayButton
    instanceHash: PropTypes.string.isRequired,
    contentBlockHash: PropTypes.string.isRequired,
    courseNodeInstance: PropTypes.object, //.isRequired,
    
    playActionId: PropTypes.string,
    onClick: PropTypes.func.isRequired,

    // used by google classroom integration when an assignment has been "turned in"
    customDisabled: PropTypes.bool,
    customDisabledText: PropTypes.string,

    // handle error situation
    onErrorClick: PropTypes.func,
    location: PropTypes.object.isRequired,
};

const defaultProps = {
    customDisabled: false,
    customDisabledText: '',
    playActionId: null,
};

class StudentContentBlockPlayButton extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {};
    }
    
    componentDidMount() {
        // redmine #4895 - bypass student assignment page ( via play=1 specified in url )
        // const shouldAutoPlay = !!UriUtil.parseLocationSearchString(this.props.location).play;
        // if (this.props.onClick && shouldAutoPlay) {
        //     this.checkToPlay();
        // }
    }

    /*canPlay=()=>{
        if (this.props.customDisabled) {
            return false;
        }

        if (!this.props.courseNodeInstance) {
            return true;
        }

        let nodeInstanceBeforeStart = false;
        let nodeInstanceAfterEnd = false;
        const thisMoment = moment(new Date());
        if (this.props.courseNodeInstance.start_date) {
            const startMoment = moment(this.props.courseNodeInstance.start_date);
            nodeInstanceBeforeStart = (thisMoment < startMoment);
        }
        if (this.props.courseNodeInstance.end_date) {
            const endMoment = moment(this.props.courseNodeInstance.end_date);
            nodeInstanceAfterEnd = (thisMoment > endMoment);
        }
        
        if (nodeInstanceBeforeStart) {
            return false;
        }
        
        if (nodeInstanceAfterEnd) {
            return false;
        }

        return true;
    }*/
    
    /*checkToPlay=()=>{
        if (this.canPlay()) {
            this.props.onClick();
        }
    }*/

    render() {        
        let nodeInstanceBeforeStart = false;
        let nodeInstanceAfterEnd = false;
        const thisMoment = moment(new Date());

        if (!!this.props.courseNodeInstance) { // TEMP allow omission of this for now
            if (this.props.courseNodeInstance.start_date) {
                const startMoment = moment(this.props.courseNodeInstance.start_date);
                nodeInstanceBeforeStart = (thisMoment < startMoment);
            }
            if (this.props.courseNodeInstance.end_date) {
                const endMoment = moment(this.props.courseNodeInstance.end_date);
                nodeInstanceAfterEnd = (thisMoment > endMoment);
            }
        }

        let playButtonAreaElem = null;
        let playButtonAreaContents = null;
        let playButtonElem;

        if (this.props.customDisabled) {
            playButtonElem = <h2>{this.props.customDisabledText || 'Unavailable'}</h2>
        }
        else if (nodeInstanceBeforeStart) {
            playButtonElem = <h2>Node hasn't started.</h2>
        }
        else if (nodeInstanceAfterEnd) {
            playButtonElem = <h2>Node has ended.</h2>
        }
        else {
            // let activeAttempt = AssignmentStore.getActiveAttemptForStudentAssignment(this.props.instanceHash, _user.id); // TODO
            let showButton;
            let showErrorButton = false;
            let message;
            let subMessage = '';
            /* TODO work out logic for determining current/next attempt for content block
            switch (activeAttempt.user_status) {
                case Globals.attempt.user_statuses.NEW: {
                    //start attempt
                    showButton = true;
                    message = 'Play Content Block';
                    subMessage = `Attempt ${activeAttempt.attempt}`;
                    break;
                }

                case Globals.attempt.user_statuses.STARTED:
                case Globals.attempt.user_statuses.IN_PROGRESS:
                    //resume attempt
                    showButton = true;
                    message = 'Resume Content Block';
                    subMessage = `Attempt ${activeAttempt.attempt}`;
                    break;

                case Globals.attempt.user_statuses.COMPLETE: {
                    // start new attempt
                    showButton = true;
                    message = 'Play Content Block';
                    subMessage = `Attempt ${(activeAttempt.attempt + 1)}`;

                    break;
                }

                case Globals.attempt.user_statuses.ERROR:
                case Globals.attempt.user_statuses.ERROR_SENDSCORE:
                    //error message
                    showButton = false;
                    showErrorButton = true;
                    if (activeAttempt && activeAttempt.attempt) {
                        message = `Error with attempt ${activeAttempt.attempt}`;
                    }
                    else {
                        message = 'Error encountered.';
                    }
                    console.error(activeAttempt);
                    break;

                default: {
                    showButton = false
                    message = 'Error in content block (3)';
                    console.error(activeAttempt);
                    break;
                }
            }*/

            // TEMP
            showButton = true;
            message = 'Play';
            //subMessage = `Attempt ${'X'}`;

            if (showButton) {
                playButtonElem = (
                    <Button
                        bsPrefix="btn btn-primary btn-lg"
                        disabled={!!this.props.playActionId}
                        onClick={this.props.onClick}
                    >
                        <div className="text">
                            { message }
                        </div>
                        <div className="sub-text">
                            { subMessage }
                        </div>
                    </Button>
                );
            }
            else if (showErrorButton) {
                playButtonElem = (
                    <div className="play-error-button">
                        <img
                            src={GlobalConfig.StaticUrl + "/img/Oops_Stop_Sign_icon.svg.png"}
                            className="student-attempt-error-image"
                            onClick={this.props.onErrorClick}
                        />
                        <div className="text">
                            { message }
                        </div>
                        <div className="sub-text">
                            { subMessage }
                        </div>
                    </div>
                );
            }
            else {
                playButtonElem = <h2>{message}</h2>
            }
        }

        return playButtonElem;
    }
}

StudentContentBlockPlayButton.propTypes = propTypes;
StudentContentBlockPlayButton.defaultProps = defaultProps;

export default withRouter(WithContentBlockPlayButton(StudentContentBlockPlayButton));